/**
 * Swiper module: hides slides outside the visible area from screen readers and
 * the tab order (aria-hidden + inert). Visibility comes from Swiper itself
 * (watchSlidesProgress -> slideVisibleClass), so partially visible slides stay
 * reachable. inert has no visual effect, so transitions are untouched.
 */
export default function HideOffscreenSlides({ swiper, extendParams, on }) {
  extendParams({ watchSlidesProgress: true });

  function setHidden(slide, hidden) {
    slide.toggleAttribute('inert', hidden);
    if (hidden) {
      slide.setAttribute('aria-hidden', 'true');
    } else {
      slide.removeAttribute('aria-hidden');
    }
  }

  function update() {
    // No size yet (e.g. initialized inside a hidden tab): Swiper can't tell
    // what is visible, so keep everything reachable until it can.
    if (!swiper.size) return;

    swiper.slides.forEach((slide) => {
      setHidden(slide, !slide.classList.contains(swiper.params.slideVisibleClass));
    });
  }

  on('init progress', update);
  on('destroy', () => swiper.slides.forEach((slide) => setHidden(slide, false)));
}
